import { erpAxios } from '..';

const getComitentAnalysis = async (brojZahtjeva, komitent) => {
    const { data } = await erpAxios.get(`/analiza/analizaKomitenta/${brojZahtjeva}/${komitent}`);
    return data;
  };

export default getComitentAnalysis;
